import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom"
import NotFound from "../components/common/NotFound"
import AdminRoutes from "./admin.routes"
import GuestRoutes from "./guest.routes"

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {GuestRoutes}
      {AdminRoutes}
      <Route path="*" element={<NotFound />} />
    </>
  )
)

export default router